var React = require('react');

function LocationInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_material-my-location","data-name":"Icon material-my-location","d":"M10.838,7.276A3.562,3.562,0,1,0,14.4,10.838a3.561,3.561,0,0,0-3.562-3.562ZM18.8,9.948a8.01,8.01,0,0,0-7.071-7.071V1.042H9.948V2.876A8.01,8.01,0,0,0,2.876,9.948H1.042v1.781H2.876A8.01,8.01,0,0,0,9.948,18.8v1.835h1.781V18.8A8.01,8.01,0,0,0,18.8,11.729h1.835V9.948H18.8Zm-7.962,7.125a6.234,6.234,0,1,1,6.234-6.234A6.23,6.23,0,0,1,10.838,17.072Z","transform":"translate(-1.042 -1.042)","fill":"#fff"}));
}

LocationInline.defaultProps = {"width":"19.593","height":"19.593","viewBox":"0 0 19.593 19.593"};

module.exports = LocationInline;

LocationInline.default = LocationInline;
